import { render } from "./Collaborators.vue?vue&type=template&id=4597e280&scoped=true"
import script from "./Collaborators.vue?vue&type=script&lang=js"
export * from "./Collaborators.vue?vue&type=script&lang=js"

import "./Collaborators.vue?vue&type=style&index=0&id=4597e280&lang=scss&scoped=true"
import "./Collaborators.vue?vue&type=style&index=1&id=4597e280&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4597e280"]])

export default __exports__